import Vue from 'vue';

import './plugins/exception-handler';
import App from './App.vue'
import VueGtm from "vue-gtm";

import router from './router';
import store from './store';
import VueFinalModal from 'vue-final-modal';

Vue.use(VueFinalModal());

//GTMtracking
Vue.use(VueGtm, {
  id: "GTM-M9FX944K",
  defer: true,
  enabled: true,
  debug: false,
  loadScript: true,
  vueRouter: router,
  trackOnNextTick: false,
});

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
